/** Scroll a focused input into view above the mobile keyboard and fixed footers. */
export function scrollFocusedFieldIntoView(
  event: FocusEvent,
  options?: { enabled?: boolean; formSelector?: string; delayMs?: number }
): void {
  if (options?.enabled === false) {
    return;
  }
  const target = event.target as HTMLElement | null;
  if (!target) {
    return;
  }
  if (options?.formSelector && !target.closest(options.formSelector)) {
    return;
  }
  const field = target.closest('ion-item') ?? target.closest('.ion-item') ?? target;
  window.setTimeout(() => {
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, options?.delayMs ?? 300);
}
